import { connect } from 'react-redux'
import { setErrorMessage } from 'actions/account'
import {
  setCartLocation,
  setCartDays,
  setCartAcknowledgedSoftClose
} from 'actions/account/cart'

const mapStateToProps = ({ cart: { cartForm } }) => ({ cartForm })
const actions = {
  setErrorMessage,
  setCartLocation,
  setCartDays,
  setCartAcknowledgedSoftClose
}

const withRedux = connect(mapStateToProps, actions)

export default withRedux
